export default __webpack_public_path__ + "static/media/approve-and-rejected.9391aedc.svg";